import React, {createContext, useReducer} from "react"
import {CapabilityReducer} from "../reducers/CapabilityReducer";
import {DEFAULT_REFRESH_INTERVAL} from "../../util/Constants";

export const CapabilityContext = createContext()
const model = {
    capability: '',
    baseUrl: '',
    stationConfig: {
        initialised: false,
        pickStageDecoupleEnabled: false,
        plannedDispatchTimeEnabled: false,
        splitStagingEnabled: false,
        highSPREnabled: false,
        authEnabled: false,
        amxl: false,
        refreshInterval: DEFAULT_REFRESH_INTERVAL,
        stagenabled : false,
        ssdmmotenabled: false,
        loadGuideSheetDownloadEnabled: false
    }
}
const CapabilityContextProvider = (props) => {
    const [configViewModel, configDispatch] = useReducer(CapabilityReducer, model)
    return (
        <CapabilityContext.Provider value={{configViewModel, configDispatch}}>
            {props.children}
        </CapabilityContext.Provider>
    )
}

export default CapabilityContextProvider


// WEBPACK FOOTER //
// ./src/components/global/context/CapabilityContext.js